module.exports = __webpack_public_path__ + "img/invitationZhM.30f4c47d.jpg";